module.exports = __webpack_public_path__ + "static/media/overview-team-lead.16691bae.svg";